import {
    KOREA_REVENUE_SUCCESS,
    KOREA_REVENUE_LOADING,
  } from '../actions/KoreaRevenueAction';
  
  const initialState = {
    revenueData: [],
    isLoading: true
  };
  
  const KoreaRevenueReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case KOREA_REVENUE_SUCCESS:
        return { ...state, revenueData: action.data, isLoading: false };
      case KOREA_REVENUE_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default KoreaRevenueReducer;
  